export default function Movements() {
  return (
    <div className="card">
      <div>
      <h3 align="left">Transactions</h3>
      <h5 align="right">Export</h5>
      </div>
      <table width={100}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Transaction Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr className="positive">
            <td>2025-07-04</td>
            <td>Deposit</td>
            <td className="right">+ € 150.000,00</td>
          </tr>

          <tr className="negative">
            <td>2025-12-29</td>
            <td>Whithdrawal</td>
            <td className="right">- € 50.000,00</td>
          </tr>

          <tr className="waiting">
            <td>2025-12-30</td>
            <td>Waiting for confirmation</td>
            <td className="right">+ € 35.000,00</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}